import {createSelector} from 'reselect'
import keyBy from 'lodash/keyBy.js'
import sortBy from 'lodash/sortBy.js'

import {setForm, updateForm, formsSelector} from '../store.js'
import {fetchAllAPI} from '../common/fetchAll.js'

export const USERS = 'users'

export function usersSelector(state) {
  return formsSelector(state)[USERS] || usersSelector.default
}
usersSelector.default = {}

export function usersHaveLoadedSelector(state) {
  return !!formsSelector(state)[USERS]
}

export function userSelector(state, {userID}) {
  return usersSelector(state)[userID]
}

export const usersSortedByNameSelector = createSelector(
  usersSelector,
  (users) => sortBy(users, 'name'),
)

export const activeUsersSortedByNameSelector = createSelector(
  usersSortedByNameSelector,
  (users) =>
    users.filter(
      (user) => user.is_active && !user.is_api_user && !user.archive_date,
    ),
)

export const userCountSelector = createSelector(
  activeUsersSortedByNameSelector,
  (users) => users.length,
)

export function setUsers(users) {
  setForm(USERS, keyBy(users, 'id'))
}

export function setUser(user) {
  updateForm(USERS, {[user.id]: user})
}

export async function getUsers() {
  const users = await fetchAllAPI('/user/', 'user')

  setUsers(users)
}
